import { render } from "./PostIt.vue?vue&type=template&id=56fcc08e&scoped=true"
import script from "./PostIt.vue?vue&type=script&lang=js"
export * from "./PostIt.vue?vue&type=script&lang=js"

import "./PostIt.vue?vue&type=style&index=0&id=56fcc08e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fcc08e"]])

export default __exports__